export class UserSearchInterface {
  id?: string;
  username?: string;
  imageUrl?: string;
  firstName?: string;
  lastName?: string;
}
